import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = () => {
  const { token } = useSelector((state) => state.user);
  const storedToken = localStorage.getItem("token");

  if (token || storedToken) {
    return <Navigate to="/dashboard/main" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
